export class BaileysVersionEntity {
    id?: string;
    version!: string;
    createdAt?: string;
    updatedAt?: string;

    constructor({
                    id,
                    version,
                    createdAt,
                    updatedAt,
                }: {
        id?: string;
        version: string;
        createdAt?: string;
        updatedAt?: string;
    }) {
        Object.assign(this, {
            id,
            version,
            createdAt,
            updatedAt,
        });
    }

    public static fromJson(json: Record<string, any>): BaileysVersionEntity {
        return new BaileysVersionEntity({
            id: json['id'],
            version: json['version'],
            createdAt: json['createdAt'],
            updatedAt: json['updatedAt'],
        });
    }
}
